import { Heading4, TextL } from 'app/components';
import { IFgtsMargin } from '../interfaces';
import { StyledContainer } from '../styles';
import { formatCurrency } from 'app/utils/normalizer';
import { useTheme } from '@mui/material';

type FgtsMarginInfoProps = {
  fgtsMargin?: IFgtsMargin;
};

const FgtsMarginInfo = ({ fgtsMargin }: FgtsMarginInfoProps) => {
  const theme = useTheme();

  return (
    <StyledContainer>
      <Heading4 style={{ color: theme.palette.brand.primary.base }}>
        Saldo FGTS:
      </Heading4>
      <br />
      <TextL>
        {formatCurrency(fgtsMargin?.available_fgts_guarantee_balance) ||
          'Não informado'}
      </TextL>
      <div style={{ height: '3rem' }} />
      <Heading4 style={{ color: theme.palette.brand.primary.base }}>
        Valor da multa rescisória associada ao FGTS:
      </Heading4>
      <br />
      <TextL>
        {formatCurrency(fgtsMargin?.severance_fine_fgts_guarantee) ||
          'Não informado'}
      </TextL>
    </StyledContainer>
  );
};

export default FgtsMarginInfo;
